export default {
  options: {
    units: {
      kilometers: 'Chilometri',
      meters: 'Metri',
      miles: 'Miglia'
    },
    areUnits: {
      sqKms: 'Chilometri quadrati',
      hectare: 'Ettaro',
      sqMeters: 'Metri quadrati'
    }
  }
}
